export const checkArray = (Param) => !!Param && Param.constructor === Array
